import React, { useState } from 'react'
import { Modal, Header, Segment, TextArea } from 'semantic-ui-react'
import styled from 'styled-components'

import IFrame from 'components/IFrame'
import SurveyPublishDescription from 'components/SurveyPublishDescription'

/**
 * @typedef Description
 * @property {string} content A string with new line character (\n). Each line will be wrapped in a <p> tag.
 * @property {string} linkText
 * @property {string} linkUrl
 *
 *
 * @param {object} props
 * @param {Description} props.description
 * @param {string} props.className
 * @param {string} props.htmlEmbedCode
 * @param {number} props.iframeHeight
 * @param {string} props.ratingLinkWihtoutValue
 * @returns
 */
export default function GenerateIntercomEmbedCodeModal({
  description,
  className,
  htmlEmbedCode,
  iframeHeight,
  ratingLinkWihtoutValue,
}) {
  const [embedCodeType, setEmbedCodeType] = useState('visual')
  const [copySurveyButtonText, setCopySurveyButtonText] = useState('Copy survey')

  function handleSelectAndCopyContent(embedCodeType) {
    if (embedCodeType === 'link') {
      copyIframeLink()
    }

    if (embedCodeType === 'visual') {
      copyIframeVisualHTML()
    }

    setCopySurveyButtonText('Copied!')
  }

  function copyIframeLink() {
    const embed = document.getElementById('embedLinkArea')
    embed.select()
    document.execCommand('copy')
  }

  function copyIframeVisualHTML() {
    const iframe = document.querySelectorAll('#embedArea iframe')[0]
    const iframeDocument = iframe.contentWindow.document
    const range = iframeDocument.createRange()
    range.selectNodeContents(iframeDocument)
    const selection = iframe.contentWindow.getSelection()
    selection.removeAllRanges()
    selection.addRange(range)
    iframeDocument.execCommand('copy')
  }

  function handleToggleEmbedCodeType(type) {
    setEmbedCodeType(type)
  }

  return (
    <Modal
      trigger={
        <a className={`ui huge primary generate-embed button ${className}`}>Generate embed code</a>
      }
      size="small"
    >
      <Header>
        <div className="header">
          Copy your embed code
          <div className="ui mini basic buttons right floated">
            <a
              className={`ui button ${embedCodeType === 'visual' && 'active'}`}
              onClick={() => handleToggleEmbedCodeType('visual')}
            >
              <i className="icon far fa-images" />
              Visual
            </a>
            <a
              className={`ui button ${embedCodeType === 'link' && 'active'}`}
              onClick={() => handleToggleEmbedCodeType('link')}
            >
              <i className="icon far fa-link" />
              Link
            </a>
          </div>
        </div>
      </Header>
      <Modal.Content>
        <div className="description">
          <SurveyPublishDescription
            content={description.content}
            linkText={description.linkText}
            linkUrl={description.linkUrl}
          />
          <EmbedContent
            embedCodeType={embedCodeType}
            htmlEmbedCode={htmlEmbedCode}
            iframeHeight={iframeHeight}
            ratingLinkWihtoutValue={ratingLinkWihtoutValue}
          />
          <a
            className="ui fluid large primary button"
            onClick={() => handleSelectAndCopyContent(embedCodeType)}
          >
            {copySurveyButtonText}
          </a>
        </div>
      </Modal.Content>
    </Modal>
  )
}

/**
 *
 * @param {object} props
 * @param {string} props.embedCodeType
 * @param {string} props.htmlEmbedCode
 * @param {number} props.iframeHeight
 * @param {string} props.ratingLinkWihtoutValue
 */
function EmbedContent({ embedCodeType, htmlEmbedCode, iframeHeight, ratingLinkWihtoutValue }) {
  if (embedCodeType === 'visual') {
    return <VisaulHTMLContent htmlEmbedCode={htmlEmbedCode} iframeHeight={iframeHeight} />
  }

  if (embedCodeType === 'link') {
    return <LinkContent ratingLinkWihtoutValue={ratingLinkWihtoutValue} />
  }

  return null
}

/**
 *
 * @param {object} props
 * @param {string} props.htmlEmbedCode
 * @param {number} props.iframeHeight
 */
function VisaulHTMLContent({ htmlEmbedCode, iframeHeight }) {
  return (
    <Segment padded="very">
      <div id="embedArea">
        <IFrame
          height={iframeHeight}
          sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        >
          <div
            id="iframe-content"
            style={{ fontFamily: 'Lato, Helvetica, Arial, sans-serif' }}
            dangerouslySetInnerHTML={{
              __html: htmlEmbedCode,
            }}
          />
        </IFrame>
      </div>
    </Segment>
  )
}

const StyledTextArea = styled(TextArea)`
  width: 100%;
  font-family: 'Lato';
`

/**
 *
 * @param {object} props
 * @param {string} props.ratingLinkWihtoutValue
 */
function LinkContent({ ratingLinkWihtoutValue }) {
  function handleClickEmbedCodeArea(e) {
    e.target.select()
  }

  return (
    <Segment padded>
      <div className="ui form" style={{ wordWrap: 'break-word' }}>
        <div className="field">
          <StyledTextArea
            id="embedLinkArea"
            rows={10}
            onClick={handleClickEmbedCodeArea}
            spellCheck={false}
            value={ratingLinkWihtoutValue}
          />
        </div>
      </div>
    </Segment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntercomTextPublish/GenerateIntercomEmbedCodeModal.js